import { render, staticRenderFns } from "./Short_form_Customize.vue?vue&type=template&id=7711f5bf&scoped=true&"
import script from "./Short_form_Customize.vue?vue&type=script&lang=js&"
export * from "./Short_form_Customize.vue?vue&type=script&lang=js&"
import style0 from "./Short_form_Customize.vue?vue&type=style&index=0&id=7711f5bf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7711f5bf",
  null
  
)

export default component.exports